import axios from "axios";
import AuthService from '../security/AuthService';



const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json; charset=UTF-8"
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = AuthService.getToken();

//    console.log("intercepto token", token, config);

    let url = config?.url?.url ? config?.url?.url : config?.url;
    if (token && token != null && !url.includes("/authentication/signin") && !url.includes("/authentication/register") && !url.includes("/authentication/signin")) {
      config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      //config.headers["x-access-token"] = token; // for Node.js Express back-end
    } else {
      if (!url.includes("/authentication/register"))
        config.headers["Authorization"] = null;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

 //   console.log("intercepto err", err?.response?.status);
    if (originalConfig && !originalConfig.url.includes("/authentication/signin") && !originalConfig.url.includes("/authentication/signout") && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instance.post("/users/refresh", {
            refreshToken: AuthService.getToken(),
          });

          const { accessToken } = rs.data;
          console.log("intercepto", accessToken);
          AuthService.Authorization(accessToken);

          return instance(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);


export default instance;
